import React from 'react';
import FloatingDialog, {
    IFloatingDialogMargins,
} from '../common/floating-dialog';
import TicketBoughtLine from './ticket-bought-line';
import TicketBoughtManageOrderLine from './ticket-bought-manage-order-line';

interface ITicketBoughtFloatingDialog {
    arrowDialog?: 'top' | 'bottom';
    manageOrderUrl: string;
    isDisplay?: boolean;
    position: { x: number; y: number };
    positionType: 'arrow' | 'corner';
    removePanel?: () => void;
    viewport: { width: number; height: number };
    margins: IFloatingDialogMargins;
    ticket: {
        price: string;
        row: string;
        seat: string;
        section: string;
        tier: string;
        username: string;
    };
}

const TicketBoughtFloatingDialog = ({
    arrowDialog,
    isDisplay,
    manageOrderUrl,
    margins,
    position,
    positionType,
    removePanel,
    ticket,
    viewport,
}: ITicketBoughtFloatingDialog): React.ReactElement => (
    <FloatingDialog
        arrowDialog={arrowDialog}
        position={position}
        isDisplay={isDisplay}
        removePanel={removePanel}
        positionType={positionType}
        viewport={viewport}
        margins={margins}
    >
        <TicketBoughtLine ticket={ticket} />
        <TicketBoughtManageOrderLine manageOrderUrl={manageOrderUrl} />
    </FloatingDialog>
);

export default TicketBoughtFloatingDialog;
